import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { Container } from "reactstrap";
import { Box, Button, Stack, SvgIcon, Typography, Grid, Snackbar, TextField, Checkbox } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'
import axios from 'axios'
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Controller, useForm } from 'react-hook-form'
// import { useRouter, withRouter } from 'next/router'
import { useAlert } from 'react-alert'
import { DataGrid } from '@mui/x-data-grid'
import Tooltip from '@mui/material/Tooltip'
import TabPanel from "@mui/lab/TabPanel";
import ReactSelect from 'react-select';
import Swal from "sweetalert2";

import Moment from 'moment'
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
// import { createBrowserHistory } from 'history'
// import { useHistory } from "react-router-dom";
// import { Navigate } from "react-router-dom";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import { useNavigate } from 'react-router-dom';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import DeleteIcon from '@mui/icons-material/Delete'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import "../Button.css"
import ComItem from '../ComItem';
import { useSelector } from "react-redux";

// const history = useHistory();
const Todolist = () => {

  const [isLoading, setLoading] = useState(false)
  document.title = "Todolist | LuxBilling";
  const rights = useSelector((state) => state.login.rights);

  // document.title = "Dashboard | Upzet - React Admin & Dashboard Template";

  // const auth = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJqdGkiOiIwZmRiNWIxMy0wYzExLTQ4ZTQtOTdmMy1hZjhlOGNmOTJlMjgiLCJ2YWxpZCI6IjEiLCJ1c2VyRW1haWwiOiJhbGlAZ21haWwuY29tIiwicHJhY3RpY2VJZCI6IjEiLCJleHBpcnlEYXRlIjoiNy8zLzIwMjgiLCJicm93c2VyIjoiR29vZ2xlIENocm9tZSIsImFwcGxpY2F0aW9uIjoiTHV4QmlsbGluZyIsIklzQWRtaW4iOiJGYWxzZSIsIlByb3ZpZGVySWQiOiIwIiwiZXhwIjoxODQ2MDgwNTE2LCJpc3MiOiJodHRwOi8vd3d3Lkx1eEJpbGxpbmcuY29tIiwiYXVkIjoiaHR0cDovL3d3dy5MdXhCaWxsaW5nLmNvbSJ9.2Uac6a-c-IPRJFzYSvjxpRych9icwhsebjvB2lgZaOs`
  const navigate = useNavigate();
  const [rows, setRows] = useState(null)
  const [rows1, setRows1] = useState(null)
  const [resolved, setresolved] = useState(false)
  console.log('resolved', resolved)
  const [refresh, setRefresh] = useState(false)

  const token = localStorage.getItem('Token')
  const Usertype = localStorage.getItem('User_Type')

  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }

  const [opentodolist, setopentodolist] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [selectedOption, setSelectedOption] =  useState(
  Usertype === 'Front Office' || Usertype === 'Front Office Admin'
    ? localStorage.getItem('default_paractice')
    : -1
);
  const fields = [
    'id',
    'patientId',
    'patientNoteId',
    'name',
    'shortName',
    'type',
    'phoneNo',
    'fax',
    'emailAddress',
    'city',
    'state',
    'zipCode',
    'deleted',
    'createdBy',
    'createdDate',
    'updatedBy',
    'updatedDate',
    'clientCreatedDate',
    'clientModifiedDate',
    'defaultPOS',
    'practice_id',
    'defaultFacility',
    'npi',
    'fullName',
    'address',
    'date',
    'patientName',
    'comments',
    'dueDate',
    'assignedTo',
    'archive',
    'allData'
  ]
  const defValues = {
    id: 0,
    patientName: '',
    patientId: '',
    patientNoteId: 0,
    address: '',
    fullName: '',
    shortName: '',
    type: '',
    phoneNo: '',
    fax: '',
    emailAddress: '',
    city: '',
    state: '',
    zipCode: '',
    deleted: false,
    createdBy: '',
    practice_id: '',
    createdDate: '',
    updatedBy: '',
    updatedDate: '',
    clientCreatedDate: '',
    clientModifiedDate: '',
    defaultPOS: '',
    defaultFacility: '',
    npi: '',
    fullName: '',
    address: '',
    date: '',
    comments: '',
    dueDate: '',
    assignedTo: '',
    archive: '',
    allData: ''
  }
  const [commentId, setID] = React.useState('')
  const columns1 = [
    {
      field: 'id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.2,
    },

    {
      field: 'patientName',
      headerName: 'Patient Name',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.5,
      renderCell: (cellValues) => (
        <Button
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            // openPracticesRegistration(cellValues.row.id )
            // setopentodolist(true)
            setOpens(true)
            setID(cellValues.row.id)
            setPatientName(cellValues.row.patientName)
            setPatientID(cellValues.row.patientId)
            setresolved(cellValues.row.archive)
          }}
        >{`${cellValues.row.patientName}`}</Button>
      ),
    },
    {
      field: 'assignedTo',
      headerName: 'Assigned To',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.8,
    },
    {
      field: 'Comments',
      headerName: 'Message',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 1,
    },
    {
      field: 'dueDate',
      headerClassName: 'super-app-theme--header',
      headerName: 'Due Date',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.5,
    },
    // ...(isChecked
    //   ? [{
    //     field: 'practiceName',
    //     headerName: 'Practice Name',
    //     headerClassName: 'super-app-theme--header',
    //     cellClassName: 'gridCell',
    //     sortable: false,
    //     flex: 0.9,
    //   }]
    //   : []
    // ),
    ...(rights?.Delete_Todo
      ? [
    {
      field: 'deleted',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.2,
      // hide: true,
      // hide: Usertype == 'Admin'?false:true,

        renderCell: (cell) => (

        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer'
          }}

          onClick={() => {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the record.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6c7c84",
          heightAuto: false,
          backdrop: true,
          didOpen: () => {
            // ✅ z-index fix (same pattern as before)
            const popup = document.querySelector(".swal2-popup");
            const container = document.querySelector(".swal2-container");
            const backdrop = document.querySelector(".swal2-backdrop");

            if (popup) popup.style.zIndex = "1801";
            if (container) container.style.zIndex = "1801";
            if (backdrop) backdrop.style.zIndex = "1800";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const postData = {
              id: cell.row.id,   // ✅ correct DataGrid access
              deleted: true,
            };

            axios
              .post(
                `${process.env.REACT_APP_API_URL}/PatientToDoList/AddPatientToDoList`,
                postData,
                { headers }
              )
              .then(() => {
                setRefresh(!refresh);

                // ✅ optional success auto-close
                Swal.fire({
                  title: "Deleted!",
                  text: "Record deleted successfully.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1200,
                  heightAuto: false,
                });
              })
              .catch((error) => {
                console.error("There was an error!", error);

                Swal.fire({
                  title: "Error!",
                  text: "Something went wrong.",
                  icon: "error",
                  heightAuto: false,
                });
              });
          }
        });
      }}
        ></DeleteIcon>
      )
    }
  ]
  : [])
  ]
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.2,
    },

    {
      field: 'patientName',
      headerName: 'Patient Name',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.5,
      renderCell: (cellValues) => (
        <Button
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            // openPracticesRegistration(cellValues.row.id )
            // setopentodolist(true)
            setOpens(true)
            setID(cellValues.row.id)
            setPatientName(cellValues.row.patientName)
            setPatientID(cellValues.row.patientId)
            setresolved(cellValues.row.archive)
          }}
        >{`${cellValues.row.patientName}`}</Button>
      ),
    },
    {
      field: 'assignedTo',
      headerName: 'Assigned To',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.8,
    },
    {
      field: 'Comments',
      headerName: 'Message',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 1,
    },
    {
      field: 'dueDate',
      headerClassName: 'super-app-theme--header',
      headerName: 'Due Date',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.5,
    },
    ...(selectedOption ==-1
      ? [{
        field: 'practiceName',
        headerName: 'Practice Name',
        headerClassName: 'super-app-theme--header',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 0.9,
      }]
      : []
    ),
    ...(rights?.Delete_Todo
      ? [
    {
      field: 'deleted',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.2,
      // hide: true,
      // hide: Usertype == 'Admin'?false:true,

      renderCell: cell => (

        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer'
          }}
            onClick={() => {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the record.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6c7c84",
          heightAuto: false,
          backdrop: true,
          didOpen: () => {
            // ✅ z-index fix (same pattern as before)
            const popup = document.querySelector(".swal2-popup");
            const container = document.querySelector(".swal2-container");
            const backdrop = document.querySelector(".swal2-backdrop");

            if (popup) popup.style.zIndex = "1801";
            if (container) container.style.zIndex = "1801";
            if (backdrop) backdrop.style.zIndex = "1800";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const postData = {
              id: cell.row.id,   // ✅ correct DataGrid access
              deleted: true,
            };

            axios
              .post(
                `${process.env.REACT_APP_API_URL}/PatientToDoList/AddPatientToDoList`,
                postData,
                { headers }
              )
              .then(() => {
                setRefresh(!refresh);

                // ✅ optional success auto-close
                Swal.fire({
                  title: "Deleted!",
                  text: "Record deleted successfully.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1200,
                  heightAuto: false,
                });
              })
              .catch((error) => {
                console.error("There was an error!", error);

                Swal.fire({
                  title: "Error!",
                  text: "Something went wrong.",
                  icon: "error",
                  heightAuto: false,
                });
              });
          }
        });
      }}
        ></DeleteIcon>
      )
    }
  ]
  : [])

  ]
  const [value, setvalue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setvalue(newValue);
  };
  const alert = useAlert()
  const [patientData, setPatientData] = React.useState([])
  const [patient, setPatient] = React.useState(false)
  const [patientSelected, setPatientSelected] = React.useState(false)
  const [patientID, setPatientID] = React.useState('')
  const [dueDate, setDuedate] = React.useState()

  const [searchText, setSearchText] = useState('')
  const [patientName, setPatientName] = useState('')
  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });
  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: 'drak',
    fontSize: '13.4px !important',
    color: 'drak !important',
    borderColor: '#326C1D',
    '& .MuiDataGrid-cell:hover': {
      color: 'rgba(5, 152, 236, 0.637) !important',
      fontSize: '14.6px !important',
    },
    '& .super-app-theme--header': {
      backgroundColor: '#377562',
      borderRadius: 0.1,
      color: 'white',
      fontSize: '16px !important',

    },

  }
  const gridClasses = {
    columnHeader: 'MuiDataGrid-columnHeaders',
  };
  //    const openPracticesRegistration = (event, id) => {
  //     setopentodolist(true)
  //   }

  // const handleClose = () => {
  //   setopentodolist(false)
  //   setrefresh()
  // }
  function setrefresh() {
    setRefresh(!refresh)
  }

  const [PracticeName, setPracticeName] = useState()
    const [Practices, setPractices] = useState(null);
    const Emailaddress = localStorage.getItem("Emailaddress")
  
    useEffect(() => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/UserPractices/getUserPractices?userEmail=${Emailaddress}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(response => {
          const bprov = response.map(field => ({
            label: field.practiceName,
            value: field.practiceId,
          }));
          // setPractices(bprov);

      const updatedPractices = [{ label: "All", value: -1 }, ...bprov];

      setPractices(updatedPractices);
        })
        .catch(error => {
          console.error("Error fetching referring physicians:", error);
        });
    }, [refresh]);
    useEffect(() => {
      if (Practices && selectedOption) {
        const selected = Practices.find(option => option.value == selectedOption);
        if (selected) {
          setPracticeName(selected.label);
        }
      }
    }, [Practices, selectedOption]);

  useEffect(() => {
    if (value == 0) {
      setLoading(true)
      axios
        .get(`${process.env.REACT_APP_API_URL}/PatientToDoList/PatientToDoList?Archive=${false}&PracticeId=${selectedOption}`, {
          headers
        }
        )
        .then((response) => {
          setRows(response)
          // localStorage.setItem("ToDoCount", response.length);
          setLoading(false)
        })

        .catch((error) => {
          console.error('There was an error!', error)
        })
    }
  }, [refresh, value, selectedOption])
  useEffect(() => {
    if (value == 1) {
      setLoading(true)
      axios
        .get(`${process.env.REACT_APP_API_URL}/PatientToDoList/PatientToDoList?Archive=${true}&PracticeId=${selectedOption}`, {
          headers
        }
        )
        .then((response) => {
          setRows1(response)
          setLoading(false)
        })

        .catch((error) => {
          console.error('There was an error!', error)
        })
    }
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [refresh, value, selectedOption])

  const checkstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 250,
    bgcolor: "background.paper",
    border: "2px solid #3C7F6B",
    boxShadow: 24,

  };

  const onSubmit = (data) => {
    setSubmitting(true)
    const postData = data
    console.warn('Data: ', postData)
    // if (PracticeId !== undefined && PracticeId != null)
    //     postData.Id = PracticeId
    // else postData.Id = 0
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientToDoList/AddPatientToDoList`,
        postData,
        { headers }
      )
      .then((response) => {
        setSubmitting(false)
        alert.success('Record saved successfully.', {
          type: 'success',
          onClose: () => {
            // navigate('/Practices')
            handleClose()
          },
        })
      })
      .catch((error) => {
        setSubmitting(false)
        alert.success(`Error ${error.message}`, {
          type: 'error',
        })
      })
  }
  const onChangeHandle = async value => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setOptions
    setLoading(true);
    console.log(value)
    const sendData = {
      id: 0,
      lastName: value,
      firstName: '',
      ssn: '',
      status: '',
      cellPhone: '',
      address: '',
      dob: '',
      patientId: '',
    }
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        sendData,
        { headers },
        setPatientSelected(false)
      )
      .then(response => {
        setPatientData(response)
        setPatient(true)
        setLoading(false);
      })
      .catch(error => {
        console.error('There was an error!', error)
        setLoading(false);
      })

  }
  const PatientStyle = {
    cursor: 'pointer',
    hover: {
      background: '#3b3b3b !important',
      color: 'rgba(5, 152, 236, 0.637) !important'
    },
    color: 'green',
    selection: {
      background: '#D7624E',
      color: 'white'
    }
  }
  const [opens, setOpens] = React.useState(false)
  const handleOpen = () => setOpens(true)
  const handleClose = () => {
    setOpens(false)
    setRefresh(!refresh)
    reset()
  }

  return (

    <div className="page-content">
      <Container  >
        <Modal
          id="hello-world"
          open={opens}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true} title={'Title'} footer={'Footer'}
        >
          <Box sx={checkstyle}>



            <ComItem
              patientId={patientID}
              patientName={patientName}
              commentId={commentId}
              handleClose={handleClose}
              resolved={resolved}
            ></ComItem>

          </Box>
        </Modal>

        <div style={{ display: 'flex', justifyContent: 'space-between', height: '27px',marginBottom:'60px' }}>
          {rights.Todo_Practice_filter ? (
             <div style={{ display: 'flex',flexDirection: 'column'}}>
             <label style={{ marginBottom: '4px', fontWeight: 'bold', fontSize: '18px', color: 'black' }}>Practice Name</label>
             <ReactSelect
               options={Practices}
               value={Practices?.find(option => option.value == selectedOption)}
               onChange={(option) => {
                 setSelectedOption(option.value);
                 setPracticeName(option.label);
               }}

               styles={{
                 control: (base) => ({
                   ...base,
                   height: '40px',
                   width: '300px',
                   zIndex: 1,
                 }),
                 menuPortal: (base) => ({
                   ...base,
                   zIndex: 9999,
                 }),
                 menu: (base) => ({
                   ...base,
                   maxHeight: '400px',
                   overflowY: 'auto',
                 }),
                 menuList: (base) => ({
                   ...base,
                   maxHeight: '200px',
                   marginBottom: '10px',
                   '&::-webkit-scrollbar': {
                     width: '6px',
                   },
                   '&::-webkit-scrollbar-thumb': {
                     backgroundColor: '#aec3b0',
                     borderRadius: '10px',
                   },
                   '&::-webkit-scrollbar-thumb:hover': {
                     backgroundColor: '#8B4513',
                   },
                   '&::-webkit-scrollbar-track': {
                     backgroundColor: '#f5f5f5',
                   },
                 }),
               }}
               placeholder="Select Role"
             />
           </div>
            ) : (
              <div style={{ display: 'flex' }}></div>

          )}
          {rights.Add_Todo && (
          <Button
            className="Button"
            onClick={() => {
              reset()
              fields.forEach(field => setValue(field, ''))
              setID(0)
              setSubmitting(false)
              setPatientName('')
              handleOpen()
              // setdueDate('')
            }}
            style={{
              marginTop: "0px",
              marginBottom: "20px",
              float: "right",
              width: "200px",
              height: "35px",
              color: "white",
              fontSize: "14px",
            }}
            // onClick={setopentodolist}
            variant="contained"
          >
            <AddOutlinedIcon
              fontSize='small'
              style={{
                color: 'white',
                paddingRight: '4px',
                paddingBottom: '2px'
              }}
            ></AddOutlinedIcon>
            Add New
          </Button>
          )}
        </div>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider",marginTop:'20px' }}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="lab API tabs example"
            >
              <Tab value={0} label="New" />
              <Tab value={1} label="Completed" />

            </TabList>
          </Box>
          <TabPanel value={0}>
            <Box mb={3} marginTop={2}>
              {isLoading ? (
                <div style={{ margin: '5rem', textAlign: 'center' }}>
                  <CircularProgress />
                </div>
              ) : (
                <div style={{ height: 400, width: "100%" }}>
                  {rows === null || rows.length === 0 ? (
                    <Typography>No Record found</Typography>
                  ) : (
                    <DataGrid
                      rows={rows}
                      classes={gridClasses}
                      rowHeight={25}
                      columns={columns}

                      fullWidth
                      pagination
                      autoPageSize
                      sx={gridRowStyle}
                    />
                  )}
                </div>
              )}
            </Box>
          </TabPanel>
          <TabPanel value={1}>
            <Box mb={3} marginTop={2}>
              {isLoading ? (
                <div style={{ margin: '5rem', textAlign: 'center' }}>
                  <CircularProgress />
                </div>
              ) : (
                <div style={{ height: 400, width: "100%" }}>
                  {rows1 === null || rows1.length === 0 ? (
                    <Typography>No Record found</Typography>
                  ) : (
                    <DataGrid
                      rows={rows1}
                      classes={gridClasses}
                      rowHeight={25}
                      columns={columns1}

                      fullWidth
                      pagination
                      autoPageSize
                      sx={gridRowStyle}
                    />
                  )}
                </div>
              )}
            </Box>
          </TabPanel>
        </TabContext>


      </Container>
    </div>

  );
};

export default Todolist;
